import { Pager } from '../common/pagination.model';
import { OrderResponse } from './order.model';
import { CatalogueInfoResponse, CatalogueInfoTranslation, ProductVariant } from './product.model';

export interface ProductsToReviewResponse extends Pager {
  productsToReview: ProductsToReviewInfo[];
}

export interface ProductsToReviewInfo {
  id: number;
  img: string;
  isReviewed: boolean;
  reviewId: number | null;
  translations: CatalogueInfoTranslation[];
}

export interface CustomerReviewsResponse extends Pager {
  reviews: ReviewInfo[];
}

export interface ProductReviewsResponse extends Pager {
  reviews: ProductReviewInfo[];
}

export interface ReviewInfo {
  id: number;
  rating: number;
  title: string;
  comment: string;
  product: CatalogueInfoResponse;
}

export interface ProductReviewInfo {
  id: number;
  rating: number;
  title: string;
  comment: string;
  createdAt: Date;
  customer: {
    id: number;
    firstName: string;
    lastName: string;
  };

}

export interface Review {
  id: string;
  product_id: string;
  product_variant_id: string;
  user_id: string;
  order_id: string;
  order_item_id: string;
  rating: number;
  title: string | null;
  message: string | null;
  helpful_count: string; // Consider changing to number if it represents a count
  status: string;
  createdAt: string; // Consider using Date type if you plan to perform date operations
  updatedAt: string; // Consider using Date type if you plan to perform date operations
  deletedAt: string | null;
  product_review_galleries: ProductReviewGallery[];
  product_variant: ProductVariant;
  user: User;
}

export interface ReviewListResponse extends Pager{
  records: Review[];
  pagination: {
    total_records: number;
    total_pages: number;
    limit: number;
    page: number;
  };
}
export interface NotReviewListResponse extends Pager {
  records: ProductReview[];
  pagination: {
    total_records: number;
    total_pages: number;
    limit: number;
    page: number;
  };
}
export interface ProductReviewGallery {
  id: string;
  image_url: string;
  key: string;
}

export interface User {
  id: string;
  full_name: string;
}

export interface ProductReview {
  id: string;
  order_id: string;
  product_variant_id: string;
  quantity: number;
  unit_price: number;
  createdAt: string;
  updatedAt: string;
  order: OrderResponse;
  product_variant: ProductVariant;
  user: User;
  product_review:any|null;
}


